<h1>Banned Words</h1>
<span class="messages">
    <img src="/wp-content/themes/swarm/app/assets/images/loading.gif" *ngIf="loading" class="loader">
    <span class="save-text" *ngIf="saved"><mat-icon>check</mat-icon> Saved!</span>
    <span class="error-text" *ngIf="error"><mat-icon>error_outline</mat-icon> {{error}} </span>
    <span class="editor-text" *ngIf="canEdit && blacklistEditor"> {{blacklistEditor}} is currently editing <button type="button" class="button small" (click)="setLock('update')">Take Over</button></span>
</span>
<div>
    <div class="input-wrap search">
        <input [(ngModel)]="searchText" placeholder="Search{{ canEdit && !blacklistEditor ? '/Add' : '' }}" (input)="resetError()" (keyup.enter)="addTerm()">
    </div>
    <button type="button" *ngIf="canEdit && !blacklistEditor && searchText && !hasTerm()" (click)="addTerm()"><mat-icon>add_circle_outline</mat-icon></button>
</div>

<div 
    class="list cf" 
    [ngClass]="{
        col2: (api.getProp('blacklist') | blacklistFilter:searchText).length > 25, 
        col3: (api.getProp('blacklist') | blacklistFilter:searchText).length > 50, 
        col4: (api.getProp('blacklist') | blacklistFilter:searchText).length > 100
    }">
    <ng-container *ngFor="let key of blacklistKeys; trackBy: utils.trackByIndex">
        <div class="group" *ngIf="(blacklistObj[key] | blacklistFilter:searchText).length">
            <div class="item" *ngFor="let term of blacklistObj[key] | blacklistFilter:searchText; let i = index; trackBy: utils.trackByIndex">
                {{term}} <button type="button" *ngIf="canEdit && !blacklistEditor" (click)="removeTerm(term)"><mat-icon>remove_circle_outline</mat-icon></button>
            </div>
        </div>
    </ng-container>
</div>